export default "__VITE_ASSET__Cg4XuY77__"